import slice from './slice';

const appPackageReducer = slice.reducer;

export const { setFieldAppPackage, addItemAppPackage, removeItemAppPackage } =
  slice.actions;

export default appPackageReducer;
